export default __webpack_public_path__ + "static/media/placeholder_dummy2016-consulting01-de.248a3237.png";